import type { Supplier } from '@/types/core/purchase-planning/supplier';
import type { Option } from '@/types/data-table';

export function mapSuppliersToOptions(suppliers: Supplier[]): Option[] {
  return suppliers.map((supplier) => {
    const supplierId = String(supplier.id);

    return {
      label: supplier.name ? `${supplier.name} (${supplierId})` : supplierId,
      value: supplierId,
    };
  });
}
